 	// install a JSONP callback for chunk loading
 	function webpackJsonpCallback(data) {
 		var chunkIds = data[0];
 		var moreModules = data[1];
 		var executeModules = data[2];

 		// add "moreModules" to the modules object,
 		// then flag all "chunkIds" as loaded and fire callback
 		var moduleId, chunkId, i = 0, resolves = [];
 		for(;i < chunkIds.length; i++) {
 			chunkId = chunkIds[i];
 			if(Object.prototype.hasOwnProperty.call(installedChunks, chunkId) && installedChunks[chunkId]) {
 				resolves.push(installedChunks[chunkId][0]);
 			}
 			installedChunks[chunkId] = 0;
 		}
 		for(moduleId in moreModules) {
 			if(Object.prototype.hasOwnProperty.call(moreModules, moduleId)) {
 				modules[moduleId] = moreModules[moduleId];
 			}
 		}
 		if(parentJsonpFunction) parentJsonpFunction(data);

 		while(resolves.length) {
 			resolves.shift()();
 		}

 		// add entry modules from loaded chunk to deferred list
 		deferredModules.push.apply(deferredModules, executeModules || []);

 		// run deferred modules when all chunks ready
 		return checkDeferredModules();
 	};
 	function checkDeferredModules() {
 		var result;
 		for(var i = 0; i < deferredModules.length; i++) {
 			var deferredModule = deferredModules[i];
 			var fulfilled = true;
 			for(var j = 1; j < deferredModule.length; j++) {
 				var depId = deferredModule[j];
 				if(installedChunks[depId] !== 0) fulfilled = false;
 			}
 			if(fulfilled) {
 				deferredModules.splice(i--, 1);
 				result = __webpack_require__(__webpack_require__.s = deferredModule[0]);
 			}
 		}

 		return result;
 	}

 	// The module cache
 	var installedModules = {};

 	// object to store loaded and loading chunks
 	// undefined = chunk not loaded, null = chunk preloaded/prefetched
 	// Promise = chunk loading, 0 = chunk loaded
 	var installedChunks = {
 		3: 0
 	};

 	var deferredModules = [];

 	// script path function
 	function jsonpScriptSrc(chunkId) {
 		return __webpack_require__.p + "" + ({"0":"1cdcf93aef3b42f86db4d0f4b89087275065541b","1":"1e63433ef54c34bee89df82db62d4b380426e54d","2":"1741fef513eed36a9117166ed65840855fa4f054","5":"component---node-modules-gatsby-plugin-offline-app-shell-js","6":"component---src-pages-404-js","7":"component---src-pages-buy-neosurf-buy-neosurf-online-js","8":"component---src-pages-buy-neosurf-index-js","9":"component---src-pages-buy-neosurf-point-of-sale-js","10":"component---src-pages-buy-neosurf-spend-neosurf-js","11":"component---src-pages-casino-777-bay-js","12":"component---src-pages-casino-777-slotsbay-js","13":"component---src-pages-casino-auslots-js","14":"component---src-pages-casino-betbtc-js","15":"component---src-pages-casino-emu-js","16":"component---src-pages-casino-js","17":"component---src-pages-casino-luckystar-js","18":"component---src-pages-casino-spacelilly-js","19":"component---src-pages-de-buy-neosurf-index-js","20":"component---src-pages-de-buy-neosurf-kaufen-neosurf-online-js","21":"component---src-pages-de-buy-neosurf-spend-neosurf-js","22":"component---src-pages-de-buy-neosurf-verkaufsstelle-js","23":"component---src-pages-de-casino-777-bay-js","24":"component---src-pages-de-casino-777-slotsbay-js","25":"component---src-pages-de-casino-auslots-js","26":"component---src-pages-de-casino-betbtc-js","27":"component---src-pages-de-casino-emu-js","28":"component---src-pages-de-casino-js","29":"component---src-pages-de-casino-luckystar-js","30":"component---src-pages-de-casino-spacelilly-js","31":"component---src-pages-de-index-js","32":"component---src-pages-de-myneosurf-js","33":"component---src-pages-de-paysafecard-js","34":"component---src-pages-fr-acheter-neosurf-acheter-neosurf-en-ligne-js","35":"component---src-pages-fr-acheter-neosurf-index-js","36":"component---src-pages-fr-acheter-neosurf-point-de-vente-js","37":"component---src-pages-fr-acheter-neosurf-spend-neosurf-js","38":"component---src-pages-fr-casino-777-bay-js","39":"component---src-pages-fr-casino-777-slotsbay-js","40":"component---src-pages-fr-casino-auslots-js","41":"component---src-pages-fr-casino-betbtc-js","42":"component---src-pages-fr-casino-emu-js","43":"component---src-pages-fr-casino-js","44":"component---src-pages-fr-casino-luckystar-js","45":"component---src-pages-fr-casino-spacelilly-js","46":"component---src-pages-fr-index-js","47":"component---src-pages-fr-myneosurf-js","48":"component---src-pages-fr-paysafecard-js","49":"component---src-pages-index-js","50":"component---src-pages-myneosurf-js","51":"component---src-pages-paysafecard-js","52":"component---src-templates-blog-list-js","53":"component---src-templates-blog-post-js"}[chunkId]||chunkId) + "-" + {"0":"4f7bbaad9b18a370126d","1":"4084342c306bbedc6e13","2":"2f9a4af7536520096183","5":"36dc033f967ae9fe9cda","6":"453375c5dd9f78b8901b","7":"d87ee78be0c7a36abda8","8":"cd36bd024a8738d994d4","9":"0286f45ca31d98975321","10":"d57fb3efda396dc05b63","11":"eb59241ef3d535157854","12":"b2e0610c148d52702d2b","13":"25e90fc5ac5401534ff1","14":"d1204f08faf218a5df6b","15":"6f5a7eaa063cd5767162","16":"799a81ba25cce5f3ca8d","17":"1cc50c9c6ab3d88b73c7","18":"ccbb32b6fa2cc9a2e261","19":"255564ab6c141cb2ef13","20":"9887b4fe2d7f9a9df99e","21":"8f6be87ac5456a0cbc95","22":"dcfe5ab3616f90f8c79e","23":"ad36897ea49a824e56ed","24":"c7173c94cc94d17f4bfe","25":"0ed61acc18d7213e7d7d","26":"023f8a4f9eaf8d9ad673","27":"82199787269676b37f5d","28":"e4d799bf6d844d6bc634","29":"c29cee4c1d0d2d9ea34c","30":"c5981980eed4350378e8","31":"7b14bbf586e5ae76e21e","32":"7946e2b1c7fb3cb9d35b","33":"6c7132f3ecbdad04036d","34":"cd623e1132ffd47bde62","35":"d973fc32a26375dcdf8d","36":"2872db270c4524bbc678","37":"7dda587aa0cd57da1042","38":"24e152e3f17552d143fc","39":"847131f7297fe1424547","40":"56c6416cb351dd202abe","41":"edfdc55b34aace1172c5","42":"c2779f070f0f6d24c41b","43":"dc7417f96ef9eaf383c7","44":"bd5f6a5f980e9a40dd91","45":"ea5f5f0cbef92d1c4c88","46":"234867f5777999730156","47":"3e3cfe211898b6dd3e27","48":"f075e3ba8d9ea597a4ce","49":"c3030f772f097057a05a","50":"4120e0e7904ef52c5056","51":"fbaede4d9b4f669560cf","52":"f616687174d560ceb045","53":"9d8d02078bbda6d50031"}[chunkId] + ".js"
 	}

 	// The require function
 	function __webpack_require__(moduleId) {

 		// Check if module is in cache
 		if(installedModules[moduleId]) {
 			return installedModules[moduleId].exports;
 		}
 		// Create a new module (and put it into the cache)
 		var module = installedModules[moduleId] = {
 			i: moduleId,
 			l: false,
 			exports: {}
 		};

 		// Execute the module function
 		modules[moduleId].call(module.exports, module, module.exports, __webpack_require__);

 		// Flag the module as loaded
 		module.l = true;

 		// Return the exports of the module
 		return module.exports;
 	}

 	// This file contains only the entry chunk.
 	// The chunk loading function for additional chunks
 	__webpack_require__.e = function requireEnsure(chunkId) {
 		var promises = [];


 		// JSONP chunk loading for javascript

 		var installedChunkData = installedChunks[chunkId];
 		if(installedChunkData !== 0) { // 0 means "already installed".

 			// a Promise means "currently loading".
 			if(installedChunkData) {
 				promises.push(installedChunkData[2]);
 			} else {
 				// setup Promise in chunk cache
 				var promise = new Promise(function(resolve, reject) {
 					installedChunkData = installedChunks[chunkId] = [resolve, reject];
 				});
 				promises.push(installedChunkData[2] = promise);

 				// start chunk loading
 				var script = document.createElement('script');
 				var onScriptComplete;

 				script.charset = 'utf-8';
 				script.timeout = 120;
 				if (__webpack_require__.nc) {
 					script.setAttribute("nonce", __webpack_require__.nc);
 				}
 				script.src = jsonpScriptSrc(chunkId);

 				// create error before stack unwound to get useful stacktrace later
 				var error = new Error();
 				onScriptComplete = function (event) {
 					// avoid mem leaks in IE.
 					script.onerror = script.onload = null;
 					clearTimeout(timeout);
 					var chunk = installedChunks[chunkId];
 					if(chunk !== 0) {
 						if(chunk) {
 							var errorType = event && (event.type === 'load' ? 'missing' : event.type);
 							var realSrc = event && event.target && event.target.src;
 							error.message = 'Loading chunk ' + chunkId + ' failed.\n(' + errorType + ': ' + realSrc + ')';
 							error.name = 'ChunkLoadError';
 							error.type = errorType;
 							error.request = realSrc;
 							chunk[1](error);
 						}
 						installedChunks[chunkId] = undefined;
 					}
 				};
 				var timeout = setTimeout(function(){
 					onScriptComplete({ type: 'timeout', target: script });
 				}, 120000);
 				script.onerror = script.onload = onScriptComplete;
 				document.head.appendChild(script);
 			}
 		}
 		return Promise.all(promises);
 	};

 	// expose the modules object (__webpack_modules__)
 	__webpack_require__.m = modules;

 	// expose the module cache
 	__webpack_require__.c = installedModules;

 	// define getter function for harmony exports
 	__webpack_require__.d = function(exports, name, getter) {
 		if(!__webpack_require__.o(exports, name)) {
 			Object.defineProperty(exports, name, { enumerable: true, get: getter });
 		}
 	};

 	// define __esModule on exports
 	__webpack_require__.r = function(exports) {
 		if(typeof Symbol !== 'undefined' && Symbol.toStringTag) {
 			Object.defineProperty(exports, Symbol.toStringTag, { value: 'Module' });
 		}
 		Object.defineProperty(exports, '__esModule', { value: true });
 	};

 	// create a fake namespace object
 	// mode & 1: value is a module id, require it
 	// mode & 2: merge all properties of value into the ns
 	// mode & 4: return value when already ns object
 	// mode & 8|1: behave like require
 	__webpack_require__.t = function(value, mode) {
 		if(mode & 1) value = __webpack_require__(value);
 		if(mode & 8) return value;
 		if((mode & 4) && typeof value === 'object' && value && value.__esModule) return value;
 		var ns = Object.create(null);
 		__webpack_require__.r(ns);
 		Object.defineProperty(ns, 'default', { enumerable: true, value: value });
 		if(mode & 2 && typeof value != 'string') for(var key in value) __webpack_require__.d(ns, key, function(key) { return value[key]; }.bind(null, key));
 		return ns;
 	};

 	// getDefaultExport function for compatibility with non-harmony modules
 	__webpack_require__.n = function(module) {
 		var getter = module && module.__esModule ?
 			function getDefault() { return module['default']; } :
 			function getModuleExports() { return module; };
 		__webpack_require__.d(getter, 'a', getter);
 		return getter;
 	};

 	// Object.prototype.hasOwnProperty.call
 	__webpack_require__.o = function(object, property) { return Object.prototype.hasOwnProperty.call(object, property); };

 	// __webpack_public_path__
 	__webpack_require__.p = "/";

 	// on error function for async loading
 	__webpack_require__.oe = function(err) { console.error(err); throw err; };

 	var jsonpArray = window["webpackJsonp"] = window["webpackJsonp"] || [];
 	var oldJsonpFunction = jsonpArray.push.bind(jsonpArray);
 	jsonpArray.push = webpackJsonpCallback;
 	jsonpArray = jsonpArray.slice();
 	for(var i = 0; i < jsonpArray.length; i++) webpackJsonpCallback(jsonpArray[i]);
 	var parentJsonpFunction = oldJsonpFunction;


 	// run deferred modules from other chunks
 	checkDeferredModules();
